import * as S from "./Sidemenu.style";
// import { menuList } from "../../../data/menu";
import { useRecoilValue } from "recoil";
import { menuState } from "src/states/menu";
import { MenuItem, MenuType } from "../../../common/types/menu";
import { Permission } from "../../../common/types/permission";
import { SidemenuTop } from "../../atoms/SidemenuTop";
import SidemenuList from "../../molecules/SidemenuList";

interface SidemenuProps {
  asideToggle?: any;
  permissions: Permission[];
  onContextMenu: (event: React.MouseEvent, target: any) => void;
}

export const Sidemenu = ({
  asideToggle,
  permissions,
  onContextMenu,
}: SidemenuProps) => {
  const menuList = useRecoilValue<MenuType[]>(menuState);

  const filterMenuByPermission = (
    menuList: any[],
    permissions: Permission[]
  ): MenuItem[] => {
    const hasPermission = (title: string) => {
      const permission = permissions.find((p) => p.pmsMenuName === title);
      return permission ? permission.pmsMenuActive === 1 : 0;
    };

    const filterSubmenu = (submenu: MenuItem[]): MenuItem[] => {
      return submenu
        .map((item) => ({
          ...item,
          submenu: item.submenu ? filterSubmenu(item.submenu) : undefined,
        }))
        .filter((item) => hasPermission(item.title));
    };

    return filterSubmenu(menuList);
  };

  return (
    <S.SidemenuSection>
      <SidemenuTop asideToggle={asideToggle} />
      <SidemenuList
        menuList={filterMenuByPermission(menuList, permissions)}
        onContextMenu={onContextMenu}
      />
    </S.SidemenuSection>
  );
};
